import { AvailabilityMethod } from 'generated-graphql/graphql';
import { isRoundRobinMethod } from './isRoundRobinMethod';

// The API rejects collective ↔ round-robin on an existing template, so a
// submitted method is only honoured when it keeps the stored panel type.
// Written as a panel-type comparison rather than a value check: it used to let
// the two round-robin distributions swap, and only one of them is left.
export const resolveEditAvailabilityMethod = (
  storedMethod: AvailabilityMethod | null | undefined,
  submittedMethod: AvailabilityMethod | null | undefined
): AvailabilityMethod | undefined => {
  if (!submittedMethod) {
    return storedMethod ?? undefined;
  }

  return isRoundRobinMethod(storedMethod) ===
    isRoundRobinMethod(submittedMethod)
    ? submittedMethod
    : storedMethod ?? undefined;
};
